import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51c7bbde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "pagestyle" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = { style: {"flex":"auto"} }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  const router = useRouter()
  const searchForm:any = reactive({
    cates:[],
    cate:"",
    words:"",
    limit:10,
    page:1,
  })
  const propss = {
    expandTrigger: 'hover' as const,
    value:'id',
    label:'title',
    children:'Children',
  }
  const baseData:any = reactive({
    loading:false,
    title:'',
    examinebox:false,
    goodsdrawer:false,
    cateslist:[],
    remarklog:[],
    goods:{},
    examineRemark:""
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleChange = (value:any) => {
    searchForm.cate = value[value.length - 1]
  }
  const showRemark = (data:any) => {
    api.goodsApi.get_remark_log({id:data.id}).then((res:any)=>{
      if(res.code==200){
        baseData.goodsdrawer = true
        baseData.goods = data
        baseData.remarklog = res.data
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const showtan = (data:any) => {
    baseData.examinebox = true
    baseData.goods = data
  }
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.limit = 10
    searchForm.words = ""
    searchForm.cate = ""
    searchForm.cates = []
    getList()
  }

  const examine = (status:number) => {
    let data = {
      id:baseData.goods.id,
      status:status,
      remark:baseData.examineRemark
    }
    
    api.goodsApi.examine(data).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.examinebox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const changeGoodStatus = (id:string) =>{
    api.goodsApi.changeGoodStatus({id:id}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
      }else{
        ElMessage.error(res.message)
      }
      getList()
    })
  }
  const getList = () => {
    localStorage.setItem('goodspage',searchForm.page);
    localStorage.setItem('goodscate',searchForm.cate);
    localStorage.setItem('goodswords',searchForm.words);
    localStorage.setItem('goodslimit',searchForm.limit);
    baseData.loading = true
    api.goodsApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        let list = res.data.list
        for(let i in list){
          list[i].Status = list[i].Status==1?true:false
        }
        tableData.data = list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = (id:any) => {
    router.push("/goods/add");
  }
  const edit = (id:any) => {
    router.push("/goods/edit/"+id);
  }
  const del = (id:number) => {
    baseData.loading = true
    api.goodsApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getCatesList = () => {
    baseData.loading = true
    api.goodsApi.get_cates_list({limit:1000,page:1}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.cateslist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    searchForm.page = localStorage.getItem('goodspage') ? parseInt(localStorage.getItem('goodspage')) : 1;
    searchForm.cate = localStorage.getItem('goodscate') ? localStorage.getItem('goodscate') : '';
    searchForm.words = localStorage.getItem('goodswords') ? localStorage.getItem('goodswords') : '';
    searchForm.limit = localStorage.getItem('goodslimit') ? parseInt(localStorage.getItem('goodslimit')) : 10;
    getList()
    getCatesList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("产品列表")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "editbtn",
            onClick: add
          }, {
            default: _withCtx(() => [
              _createTextVNode("创建产品")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: searchForm,
          inline: "",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "产品品类" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: searchForm.cates,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.cates) = $event)),
                  options: baseData.cateslist,
                  props: propss,
                  clearable: "",
                  onChange: handleChange
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "关键词" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: searchForm.words,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.words) = $event)),
                  placeholder: "产品名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: reset }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "id",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "img",
              label: "封面图",
              width: "140"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_image, {
                  style: {"width":"100px","height":"100px"},
                  src: scope.row.img,
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "产品名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "catagory",
              label: "分类名称",
              width: "140"
            }),
            _createVNode(_component_el_table_column, {
              prop: "introduction",
              label: "简介"
            }),
            _createVNode(_component_el_table_column, {
              prop: "click",
              label: "游览量",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "remark",
              label: "备注"
            }, {
              default: _withCtx((scope) => [
                (scope.row.remark)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(scope.row.remark), 1))
                  : _createCommentVNode("", true),
                (scope.row.remark)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "success",
                      onClick: ($event: any) => (showRemark(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查看记录 > ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "创建时间",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "状态",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status==0)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 0,
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("冻结")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.status==1)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 1,
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("待审核")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.status==2)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 2,
                      type: "success"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.status==3)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 3,
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("审核不通过")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "200"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (showtan(scope.row)),
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("审核")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (edit(scope.row.id)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_popconfirm, {
                  "confirm-button-text": "是",
                  "cancel-button-text": "否",
                  title: "确定删除吗?",
                  onConfirm: ($event: any) => (del(scope.row.id))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.examinebox,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((baseData.examinebox) = $event)),
      title: "审核",
      width: "80%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (baseData.examinebox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (examine(3)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("审核不成功")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (examine(2)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("审核成功")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions, {
          title: "商品信息",
          column: 3,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(baseData.goods.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "所属公司" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(baseData.goods.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "分类名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(baseData.goods.catagory), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "推荐" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(baseData.goods.recommend ? "是" : "否"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "简介" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(baseData.goods.introduction), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "状态" }, {
              default: _withCtx(() => [
                (baseData.goods.status==0)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 0,
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("冻结")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (baseData.goods.status==1)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 1,
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("待审核")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (baseData.goods.status==2)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 2,
                      type: "success"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "公司轮播图" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.goods.imglist, (item) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: item.url,
                    src: item.url,
                    style: {"width":"100px","height":"100px","margin-left":"10px"}
                  }, null, 8, _hoisted_4))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "公司详情图" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.goods.detailimglist, (item) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: item.url,
                    src: item.url,
                    style: {"width":"100px","height":"100px","margin-left":"10px"}
                  }, null, 8, _hoisted_5))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, {
          model: baseData,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "备注",
              "label-width": "60"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: baseData.examineRemark,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((baseData.examineRemark) = $event)),
                  autocomplete: "off",
                  rows: 2,
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: baseData.goodsdrawer,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((baseData.goodsdrawer) = $event))
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(baseData.goods.title), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_timeline, { style: {"max-width":"600px"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.remarklog, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: index,
                  timestamp: item.created_at
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(item.remark), 1),
                    _createElementVNode("p", null, "操作人：" + _toDisplayString(item.Username), 1)
                  ]),
                  _: 2
                }, 1032, ["timestamp"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (baseData.goodsdrawer = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})